<template>
  <div id="main" ref="persisFusionContainer">
    <iframe
      id="persisMain"
      :key="url"
      ref="persisFusionFrame"
      data-name="persis-fusion-frame"
      :src="url"
      @load="iframeLoaded"
    />
  </div>
</template>

<script>
import { getIframeUrl, getUrlMainParts } from "./utils/iframeHelper.js";
import { navigationBus } from "+/components/navigation/utils/navigationBus";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      fn: this.$route.params.pdefFunction || "main",
      action: this.$route.params.pdefAction || undefined,
      loading: true
    };
  },
  computed: {
    ...mapGetters("menu", ["getAtomMenuFlat"]),
    url() {
      let query = "";
      if (this.$route.query["__sh"]) {
        query += "__sh=" + this.$route.query["__sh"] + "&";
      }
      query += "fn=" + this.fn;
      if (this.action) {
        query += "&action=" + this.action;
      }
      query += this.getQueries();
      return "/persis/main?" + query;
    }
  },
  watch: {
    $route() {
      this.fn = this.$route.params.pdefFunction || "main";
      this.action = this.$route.params.pdefAction || undefined;
    }
  },
  mounted() {
    this.registerPostMessageEvents();
  },
  updated() {
    this.registerIframeDocumentClick();
    this.registerNavigationEvent();
    this.registerIframeDocumentKeyupListener();
  },
  methods: {
    ...mapActions("loader", ["isLoading"]),
    ...mapActions("breadcrumb", ["updateBreadcrumb"]),

    iframeClick() {
      window.parent.postMessage("mainIframeClick", "*");
    },
    getQueries() {
      var queries = "";
      for (var item in this.$route.query) {
        if (item != "fn" && item != "action" && item != "__sh") {
          queries += "&" + item + "=" + this.$route.query[item];
        }
      }
      return queries;
    },
    hideLoader() {
      this.isLoading(false);
    },
    showLoader() {
      this.isLoading(true);
    },
    setTitle() {
      document.title = this.$refs.persisFusionFrame.contentDocument.title;
    },
    handleBreadcrumb() {
      let title = this.$refs.persisFusionFrame.contentDocument.title;
      let fullPath = getUrlMainParts(
        this.$refs.persisFusionFrame.contentDocument.URL
      );
      this.updateBreadcrumb({
        route: {
          title: title,
          fullPath: fullPath,
          to: this.$refs.persisFusionFrame.contentDocument.URL
        },
        menu: this.getAtomMenuFlat
      });
    },
    registerIframeDocumentKeyupListener() {
      this.$refs.persisFusionFrame.contentDocument.addEventListener(
        "keyup",
        this.powerUserNavigationListener
      );
    },
    registerIframeDocumentClick() {
      this.$refs.persisFusionFrame.contentDocument.addEventListener(
        "click",
        this.iframeClick
      );
    },
    powerUserNavigationListener(event) {
      if (event.altKey && event.which == 80) {
        window.parent.postMessage("openPowerUserNavigation", "*");
      }
    },
    registerNavigationEvent() {
      navigationBus.$on("navigation-item-click", (event, item) => {
        /**
        Da wir innerhalb eines Iframes navigieren, ändert sich die aktuelle Route des
        Vue-Routers nicht. Somit kann die Ursprungsseite, in die wir aus der Navigation in
        den Iframe eingestiegen sind, nicht mehr aufgerufen werden (außer, es wurde in der
        Zwischenzeit ein anderer Link im Menu geklickt). Durch Setzen der Iframe-Src erzwingen
        wir den Seitenaufruf.
         */
        if (this.$refs.persisFusionFrame !== undefined) {
          this.$refs.persisFusionFrame.src = this.url;
        }
        this.showLoader();
      });
    },
    registerPostMessageEvents() {
      window.addEventListener("message", ({ data }) => {
        if (data === "atom-loader-hide") {
          this.hideLoader();
        }
        if (data === "atom-loader-show") {
          this.showLoader();
        }
      });
    },
    iframeLoaded() {
      this.hideLoader();
      this.setTitle();
      this.handleBreadcrumb();
      history.replaceState(
        {},
        document.title,
        window.encodeURI(
          getIframeUrl(this.$refs.persisFusionFrame.contentDocument.URL)
        )
      );
      this.scrollToHash(this.$route.hash);
      this.registerIframeDocumentKeyupListener();
    },
    scrollToHash(hash) {
      if (hash) {
        const hashName = this.$route.hash.substring(1);
        const element = this.$refs.persisFusionFrame.contentWindow.document.querySelector(
          "[name='" + hashName + "']"
        );
        if (element) {
          element.scrollIntoView({
            behavior: "smooth",
            block: "start"
          });
        }
      }
    }
  }
};
</script>
